module.exports = __webpack_public_path__ + "static/media/shloka.14169268.jpeg";